<template>
  <v-layout row justify-center>
    <v-dialog v-model="showUserExercise" max-width="815"
      transition="dialog-bottom-transition" @keydown.esc="showUserExercise = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">
            {{ exercise.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showUserExercise = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-xs-center my-5" v-if="loadingRequest">
            <v-progress-circular :size="70" :width="5" indeterminate color="deep-orange darken-2"></v-progress-circular>
          </div>
          <v-container grid-list-md v-if="!loadingRequest">
            <v-layout wrap>
              <v-flex xs12>
                <youtube :video-id="videoId(exercise.video_link)" :player-vars="playerConfig"
                  v-if="exercise.video_link" player-width="680" @ready="ready"></youtube>
              </v-flex>
              <v-flex xs12 v-if="exercise.description">
                <strong>Descrição:</strong> {{ exercise.description }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

export default {
  data: () => ({
    showUserExercise: false,
    loadingRequest: false,
    exercise: {},
    exerciseTypes: [
      { name: 'Musculação', value: 'muscle' },
      { name: 'Aeróbico', value: 'aerobic' }
    ],
    playerConfig: {
      rel: 0, showInfo: 0
    },
    player: null
  }),

  methods: {
    videoId (url) {
      return this.$youtube.getIdFromURL(url)
    },

    ready (event) {
      this.player = event.target
    },

    checkIfIsClosed () {
      if (this.player) this.player.stopVideo()
    }
  },

  watch: {
    'showUserExercise': 'checkIfIsClosed'
  },

  beforeDestroy () {
    EventBus.$off('showUserExercise')
    EventBus.$off('showUserExerciseData')
  },

  mounted () {
    EventBus.$on('showUserExercise', data => {
      this.showUserExercise = data
      this.exercise = {}
    })

    EventBus.$on('showUserExerciseData', data => {
      this.loadingRequest = true
      // eslint-disable-next-line
      axios.get(`${API.userExercises}/${data._id}`).then(response => {
        this.exercise = response.data.exercise
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar o exercícios', color: 'error' })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/exercises/UserShowExercise.vue